class MasonryGrid {
  constructor() {
    this.masonry = null;
  }

  init() {
    this.initMasonry();
    this.loadMoreHandler();
  }

  initMasonry() {
    Array.from(document.querySelectorAll('.js-masonry-container')).forEach(
      () => {
        // console.log('firing each', grid, Macy);
        const macyInstance = Macy({
          // See below for all available options.
          container: '#js-masonry',
          columns: 4,

          breakAt: {
            1024: 3,
            520: 2
          }
        });

        this.masonry = macyInstance;
      }
    );
  }

  loadMoreHandler() {
    if (document.getElementById('js-load-more')) {
      const loadMore = document.getElementById('js-load-more');
      loadMore.addEventListener('click', this.loadMoreImages.bind(this));
    }
  }

  loadMoreImages(e) {
    const button = e.target;
    const url = `${main_js.ajaxurl}?action=load_more_masonry`;
    const xhr = new XMLHttpRequest();

    // Get max amount of images to load. Set in the DOM from CMS
    const imageMaxLoad = document
      .getElementById('js-masonry')
      .getAttribute('data-gallery');

    // galleryImageAjax is a variable set in the archive twig template. A comma separated string of image ids
    const galleryImageAjaxArray = galleryImageAjax.split(',');
    const imagesToLoad = galleryImageAjaxArray.slice(0, imageMaxLoad);

    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = () => {
      button.classList.add('loading');

      if (xhr.status === 200) {
        setTimeout(() => {
          this.addLodedImages(xhr.response);
          button.classList.remove('loading');
          // Remove used images from global image store variable (galleryImageAjax)
          const imagesNotLoaded = galleryImageAjaxArray.filter(
            val => !imagesToLoad.includes(val)
          );
          galleryImageAjax = imagesNotLoaded.toString();
          // If no more images to show then hide load more
          if (imagesNotLoaded.length < 1)
            document.getElementById('js-load-more').style.visibility = 'hidden';
        }, 2000);
      }
    };

    xhr.send(`images=${imagesToLoad}`);
  }

  addLodedImages(images) {
    const masonry = document.getElementById('js-masonry');
    masonry.insertAdjacentHTML('beforeend', images);

    // Set this to re calculate once images have been loaded
    this.masonry.runOnImageLoad(() => {
      this.masonry.recalculate(true);
    }, true);
  }
}

export default MasonryGrid;
